import { render, staticRenderFns } from "./CreateStaffModal.vue?vue&type=template&id=345361df&"
import script from "./CreateStaffModal.vue?vue&type=script&lang=js&"
export * from "./CreateStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateStaffModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports